import { progressBar } from "./progress-bar";

function newsPage(init) {
  const context = {};

  const updateProgressBar = progressBar($(".news-articles")[0], (amount) => {
    if (amount > 0.9 && more) {
      context.fetchCategories();
    }
  });

  let total = 0;
  let more = true;
  let fetching = false;
  context.page = 1;
  context.list = new Proxy([], {
    set(array, property, value, receive) {
      context.render([...array]);
      if (array.length >= total) {
        more = false;
      } else {
        more = true;
      }
      updateProgressBar();
      return Reflect.set(...arguments);
    },
  });

  context.start = () => {
    context.page = 1;
    $.ajax({
      type: "get",
      url: window.toUrl
        .replace("__ACTION__", "contents-meta")
        .replace("__PAGE__", 1)
        .replace("__SIZE__", 0),
      dataType: "json",
      success(count) {
        total = parseInt(count) - 3;
        context.fetchCategories();
      },
      error(xhr, ajaxOptions, thrownError) {
        console.log(
          "There was a problem loading that page. You may need to refresh."
        );
      },
    });
  };

  context.fetchCategories = () => {
    if (!fetching) {
      $.ajax({
        type: "get",
        url: window.toUrl
          .replace("__ACTION__", "contents")
          .replace("__PAGE__", context.page)
          .replace("__SIZE__", context.page > 1 ? 13 : 10),
        dataType: "json",
        beforeSend() {
          fetching = true;
        },
        success(response) {
          if (context.page === 1) {
            response.splice(0, 3);
          }
          response.forEach((item) => {
            const d = new Date(item?.news_date || null);
            const ye = new Intl.DateTimeFormat("en", {
              year: "numeric",
            }).format(d);
            const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(
              d
            );
            const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
              d
            );
            item.news_date = `${da} ${mo} ${ye}`;
            context.list.push(item);
          });
          context.page++;
        },
        error(xhr, ajaxOptions, thrownError) {
          console.log(
            "There was a problem loading that page. You may need to refresh."
          );
        },
        complete() {
          fetching = false;
        },
      });
    }
  };

  context.render = (list) => {
    if (list.length > 0) {
      const t = `
            ${list
              .map(
                (content) => `
                <a href="${content.url}" class="item" style="--image:url('${
                  content.news_image?.url || null
                }');">
                        <div class="info">
                            <div class="date">
                            <span class="fas fa-calendar"></span>
                            ${content.news_date}
                        </div>
                      <h2 class="title">${content.local.title}</h2>
                      <div class="excerpt">${content.local.excerpt}</div>
                  </div>
                </a>
            `
              )
              .join("")}
        `;
      $(".news-articles .inner .list").html(t);
    } else {
      $(".news-articles .inner .list").empty();
    }
  };

  init(context);
}

window.newsPage = newsPage;
